import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

declare global {
    interface Window {
        dataLayer: Record<string, unknown>[];
    }
}

export const AnalyticsTracker = () => {
    const location = useLocation();
    const { session, restaurantData } = useAuth();

    // Initialize dataLayer
    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
    }, []);

    // Track page views
    useEffect(() => {
        const pageViewData = {
            event: 'page_view',
            page_path: location.pathname + location.search,
            page_title: document.title,
        };

        window.dataLayer.push(pageViewData);
    }, [location]);

    // Track user identification
    useEffect(() => {
        if (session?.user) {
            const userData: Record<string, unknown> = {
                event: 'user_identified',
                user_id: session.user.id, // ID utente Supabase
                user_email: session.user.email,
                is_logged_in: true,
            };

            if (restaurantData) {
                userData.restaurant_id = restaurantData.directoryId;
                userData.restaurant_name = restaurantData.businessInfo?.name;
                userData.user_role = restaurantData.currentUserRole;
            }

            window.dataLayer.push(userData);
        } else {
            // User is not logged in or logged out
            window.dataLayer.push({
                event: 'user_identified',
                is_logged_in: false,
                user_id: null,
            });
        }
    }, [session?.user?.id, restaurantData?.directoryId]);

    return null;
};
